<template>
  <section class="editorial-intro">
    <div class="intro-top">
      <div class="intro-top__left">
        <span class="intro-label">{{ data.label }}</span>
        <h2 class="intro-title">{{ data.title }}</h2>
      </div>
      <p class="intro-copy">
        <span class="intro-copy__text">{{ data.description }}</span>
      </p>
    </div>

    <div class="intro-cards">
      <TrustCard
        v-for="(card, index) in data.cards"
        :key="index"
        :icon="card.icon"
        :title="card.title"
        :subtitle="card.description"
        :bg-color="card.bgColor"
        :badge-bg="card.badgeBg"
        :badge-border="card.badgeBorder"
        :divider-color="card.dividerColor"
      />
    </div>
  </section>
</template>

<script>
import TrustCard from "./TrustCard.vue";

export default {
  name: "EditorialIntro",
  components: { TrustCard },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.editorial-intro {
  @include theme-variable(bg-section-light);
  position: relative;
  overflow: hidden;
  padding: 48px 40px 56px;
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.intro-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  height: 140px;

  &__left {
    display: flex;
    flex-direction: column;
    gap: 18px;
    flex: 1;
  }
}

.intro-label {
  font-family: $font-family;
  font-size: 12px;
  font-weight: normal;
  color: #8c6b2f;
  letter-spacing: 1.4px;
  text-align: left;
}

.intro-title {
  font-family: $font-family;
  font-size: 48px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.04;
  margin: 0;
  max-width: 520px;
  text-align: left;
}

.intro-copy {
  max-width: 360px;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  text-align: left;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: url("~@/assets/images/homepage_intro_pattern_gold.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.15;
    pointer-events: none;
  }
}

.intro-copy__text {
  position: relative;
  font-family: $font-family;
  font-size: 15px;
  font-weight: normal;
  color: #5f5a54;
  line-height: 1.75;
}

.intro-cards {
  display: flex;
  gap: 18px;
}

// 平板适配
@media (max-width: 1199px) and (min-width: 768px) {
  .editorial-intro {
    padding: 40px 32px;
  }

  .intro-title {
    font-size: 36px;
    max-width: 440px;
  }

  .intro-copy {
    max-width: 320px;
    background-size: cover;
  }

  .intro-cards {
    gap: 16px;
  }
}

// 手机适配
@media (max-width: 767px) {
  .editorial-intro {
    padding: 32px 20px;
    gap: 16px;
  }

  .intro-top {
    flex-direction: column;
    height: auto;
    padding-right: 0;
    gap: 18px;

    &__left {
      align-items: center;
      gap: 12px;
    }
  }

  .intro-label {
    text-align: center;
  }

  .intro-title {
    font-size: 28px;
    text-align: center;
    max-width: 334px;
  }

  .intro-copy {
    font-size: 14px;
    text-align: center;
    max-width: 100%;
    background-size: cover;
    height: auto;
    min-height: 80px;
  }

  .intro-cards {
    flex-direction: column;
    gap: 14px;
  }
}
</style>
